import React, { Component } from "react";
import { Modal } from "semantic-ui-react";
import PropTypes from "prop-types";

import Player from "./Players/Player";
// import "./ResultGameModal.scss";

const ResultGameModal = ({ players, isOpen, onClose }) => {
  function _getPlayers() {
    const reversePlayers = JSON.parse(JSON.stringify(players));
    reversePlayers?.reverse();
    const resultPlayers = reversePlayers?.map(
      ({ id, numbers, prize }, index) => (
        <Player
          key={index}
          index={index + 1}
          id={id}
          balls={numbers}
          bet={prize || "0"}
          win={prize ? true : false}
        />
      )
    );
    return resultPlayers;
  }
  const _players = _getPlayers();
  return (
    <div style={{ display: isOpen ? "block" : "none" }}>
      <div className="popup">
        <div className="background"></div>
        <div className="container_an popup">
          <div className="container">
            <table className="table">
              <thead>
                <tr>
                  <th>Tickets</th>
                  <th>Boules</th>
                  <th>Gains</th>
                </tr>
              </thead>
              <tbody>
                {_players}
                <tr className="add-player-tr">
                  <td />
                  <td>
                    <div className="button-container">
                      <button className="button" onClick={onClose}>
                        OK
                      </button>
                    </div>
                  </td>
                  <td />
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResultGameModal;
